import React, { useState, useEffect } from 'react';
import TagList from '../Tags/TagList';

function ExperienceItem({ eachExp, index }) {

  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  
  const openWebBrowser = () => {
    if(eachExp.url && width > 640) {
      window.open(eachExp.url, "_blank")
    }
  }

  const openMobileBrowser = () => {
    if(eachExp.url && width < 640) {
      window.open(eachExp.url, "_blank")
    }
  }

  return (
    <li className="item-list" key={index} onClick={ openWebBrowser }>
      <div className="item-date">{eachExp.date}</div>
      <div className="item-content">
        <div className="item-title white-text" onClick={ openMobileBrowser }>
          {eachExp.title}
          <span className="download-icon">
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              viewBox="0 0 20 20" 
              fill="currentColor" 
              stroke="currentColor" 
              strokeWidth="1.5" 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              aria-hidden="true">
              <path d="M5.22 14.78a.75.75 0 001.06 0l7.22-7.22v5.69a.75.75 0 001.5 0v-7.5a.75.75 0 00-.75-.75h-7.5a.75.75 0 000 1.5h5.69l-7.22 7.22a.75.75 0 000 1.06z" />
            </svg>
          </span>
        </div>
        {/* <div className="item-body">{ eachExp.body }</div> */}
        <div className="item-body">
          <p>
            { eachExp.body }
          </p>
        </div>
        
        <TagList tagList={ eachExp.tags } />
      </div>
    </li>
  );
}

export default ExperienceItem;